import React  from 'react';
import { FaInstagram, FaLinkedin, FaCalendar, FaEnvelope } from 'react-icons/fa';
import Portfolio from './Portfolio';
import './App.css';
import NavBar from './NavBar';

const Home = () => {
  return (
      <>
      <div className="hero-image" id="home">
          <h1 className="hero-text">Ida Mayer</h1>
          <div>
          <h2 className="hero-text">Friendly Neighborhood Polymath</h2>
          <h3 className="hero-text">Coach &middot; Acrobat &middot; Designer &middot; Programmer</h3>
          </div>
      </div>

      <div className="button-container">
          <a href="https://coaching.idamayer.com" className="large-button" style={{backgroundImage: 'url("/img/grow-with-me.png")'}}>Grow with me</a>
          <a href="/classes.html" className="large-button" style={{backgroundImage: 'url("/img/train-with-me.png")'}}>Train with me</a>
          <a href="/cv.html" className="large-button" style={{backgroundImage: 'url("/img/awards-and-publications.png")'}}>Awards and Publications</a>
      </div>

      <div id="about" className="bio-section">
          <div className="bio-text">
          <h2 style={{display:'inline'}}>I seek out variety</h2>
          <p style={{display:'inline'}}> in my life. So far, I've been a Google software engineer, professional model, doubles acrobat, and I hold 4 degrees spanning humanities, techonology, and neuroscience.
            The things I'm focusing on right now are running my <a href="https://coaching.idamayer.com">productivity coaching</a> business, learning mandarin Chinese, 
          cooking up new fusion foods, singing, designing board games, and training flexibility{/*<a href="/classes">flexibility</a>*/}.</p>
          </div>
          <div className="bio-image">
          <img src="./img/bio.jpg" alt="Ida Mayer" />
          </div>
      </div>

      <Portfolio />

      <footer>
          <div className="social-icons">
          <a href="https://instagram.com/idamayeraesthetic" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://linkedin.com/in/idamayer" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
          <a href="https://cal.com/idamayer" target="_blank" rel="noopener noreferrer"><FaCalendar /></a>
          <a href="https://idamayer.com/contact.html"><FaEnvelope /></a>
          </div>
      </footer>
      </>
  );
};

const App = () => {
  return (
    <div className="webpage">
      <NavBar />
      <Home />
    </div>
  );
};

export default App;
